import { TableBodyCell, AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useApi } from 'app/domains/api-management';
export function KeyTitleCell(props) {
    const { id, name } = props;
    const { setDialog } = useApi();
    return (<TableBodyCell headers="title" onClick={() => setDialog({ type: 'view', id })}>
      <AvatarWithLabel appearance="light" solid size="md" title={name}>
        <Falcon icon="key"/>
      </AvatarWithLabel>
    </TableBodyCell>);
}
